module.exports = __webpack_public_path__ + "static/media/01d.df8cc8bc.png";